export default __webpack_public_path__ + "ce7d98202e93bed3a04351147ea668a5.png";